import { useCallback } from 'react';
import { useAuthStore } from '../stores/authStore';

export interface AuthRedirectState {
  returnTo: string;
  intent?: string;
}

export function useRequireAuth() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated || Boolean(state.user));

  return useCallback((intent: string, action: () => void) => {
    if (isAuthenticated) {
      action();
      return true;
    }

    sessionStorage.setItem('mapbl.authReturnTo', `${window.location.pathname}${window.location.search}`);
    sessionStorage.setItem('mapbl.authIntent', intent);
    window.location.assign('/register');
    return false;
  }, [isAuthenticated]);
}

export function safeAuthReturnPath(state: unknown): string {
  const stateReturnTo = state && typeof state === 'object'
    ? (state as Partial<AuthRedirectState>).returnTo
    : undefined;
  const returnTo = stateReturnTo || sessionStorage.getItem('mapbl.authReturnTo');
  clearAuthRedirectState();
  return typeof returnTo === 'string' && returnTo.startsWith('/app') ? returnTo : '/app';
}

export function clearAuthRedirectState(): void {
  sessionStorage.removeItem('mapbl.authReturnTo');
  sessionStorage.removeItem('mapbl.authIntent');
}

export function getAuthIntent(state: unknown): string | undefined {
  const stateIntent = state && typeof state === 'object'
    ? (state as Partial<AuthRedirectState>).intent
    : undefined;
  return stateIntent || sessionStorage.getItem('mapbl.authIntent') || undefined;
}
